import { api } from '../config/api'

import LocalStorageService from '../services/LocalStorageService'
import { generateFilters } from '../utils/filters'
import { defaultPageSize } from '../utils/constants'

const resourceBaseEndpoint = '/ResourceApi'

export const getResource = (id, locale) => api.get(`${resourceBaseEndpoint}/GetByLocale/${id}`, { params: { locale } })

export const getRedirectedResource = (resourceUrl) => api.get(resourceUrl, { ignoreLocale: true })

export const getAllFilteredResources = (pageNumber, pageSize = defaultPageSize, filters) => {
  // TODO: Once backend has changed the way they use the values we send
  const params = generateFilters(pageNumber, pageSize, filters)
  return api.get(`${resourceBaseEndpoint}/GetAllFiltered?${params.toString()}`)
}

export const rateResource = (rating, categories, resourceId, comment) => {
  api.post(`${resourceBaseEndpoint}/AddResourceReview`, { rating, categories, resourceId, comment })
}

export const shareResource = ({ resourceLink, recipientIds, resourceName, resourceId, locale, resourceLocale }) =>
  api.post(`${resourceBaseEndpoint}/Share`, { resourceLink, recipientIds, resourceName, resourceId, resourceLocale, ignoreLocale: true }, { params: { locale } })

export const getStudentResource = token => {
  const locale = LocalStorageService.getInnerLang()
  return api.get(`${resourceBaseEndpoint}/GetStudentResource`, token ? { params: { param: token, locale } } : {})
}

export const getRecommendedResources = (pageNumber, pageSize = 4) =>
  api.get(`${resourceBaseEndpoint}/Recommended`, { params: { pageNumber, pageSize } })

export const getAssociatedResources = (id, pageNumber, pageSize = 4) =>
  api.get(`${resourceBaseEndpoint}/AssociatedResources`, { params: { id, pageNumber, pageSize } })

export const getNewestResources = (pageNumber, pageSize = 4) =>
  api.get(`${resourceBaseEndpoint}/Newest`, { params: { pageNumber, pageSize } })

export const getCustomResources = (pageNumber, pageSize = 4, filters = {}) => {
  const params = generateFilters(pageNumber, pageSize, filters)
  return api.get(`${resourceBaseEndpoint}/Custom?${params.toString()}`)
}

export const getShareableLink = resourceId => {
  const locale = LocalStorageService.getInnerLang()
  return api.get(`${resourceBaseEndpoint}/GetShareableLink/${resourceId}`, { params: { locale } })
}

export const getUsedResourceRecords = ({ pageNumber = 0, pageSize = 5, resourceId, schoolId }) =>
  api.get(`${resourceBaseEndpoint}/${resourceId}/UsedContentRecords/${schoolId}`, { params: { pageNumber, pageSize } })

export const getAdminUsedResourceRecords = ({ pageNumber = 0, pageSize = 5, resourceId, schoolId }) =>
  api.get(`${resourceBaseEndpoint}/${resourceId}/UsedContentRecords/${schoolId}`, { params: { pageNumber, pageSize } })

export const requestResourceInformation = data =>
  api.post(`${resourceBaseEndpoint}/RequestInformation`, { ...data, ignoreLocale: true }, { params: { locale: LocalStorageService.getLang() } })
